import { gql } from '@apollo/client'

export const CONTACT_CONVERSATION_SUBSCRIPTION = gql`
  subscription ContactConversationSubscription($conversation_id: Int) {
    conversationChanged(conversation_id: $conversation_id) {
      id
      actioned
    }
  }
`
